// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__mY55X","signatureBlock":"Footer_signatureBlock__2AXgr","signature":"Footer_signature__3-DM3"};